var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"space-around"}},[_c('v-date-picker',{attrs:{"show-current":false},model:{value:(_vm.date1),callback:function ($$v) {_vm.date1=$$v},expression:"date1"}}),_c('v-date-picker',{attrs:{"show-current":"2013-07-13"},model:{value:(_vm.date2),callback:function ($$v) {_vm.date2=$$v},expression:"date2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }